import { jsxs as m, Fragment as l, jsx as t } from "react/jsx-runtime";
import { useMemo as i, useRef as p, useCallback as u, useEffect as f } from "react";
import { r as k } from "../../index-D-PSB2_0.js";
import { c as w } from "../../index-C3-ZVs5E.js";
import '../../assets/Modal.css';const y = "_backdrop_siaw6_2", b = "_modal_siaw6_11", a = {
  backdrop: y,
  modal: b
}, E = () => document.getElementById("graphapi-app-plate-root") || document.body, M = ({
  onClose: o,
  children: r,
  className: s
}) => {
  const n = i(E, []), c = p(null), e = u(
    (d) => {
      d.key === "Escape" && o();
    },
    [o]
  );
  return f(() => (window.addEventListener("keydown", e), () => {
    window.removeEventListener("keydown", e);
  }), [e]), k.createPortal(
    /* @__PURE__ */ m(l, { children: [
      /* @__PURE__ */ t("div", { className: a.backdrop, onClick: o }),
      /* @__PURE__ */ t("div", { className: w(a.modal, s), ref: c, children: r })
    ] }),
    n
  );
};
export {
  M as Modal
};
